export const FILTER_KEYS_BY_ORDER = [
  "VehicleType",
  "Make",
  "ModelGroup",
  "Model",
  "Derivative",
  "SaleDate",
  "SaleLocation",
  "SaleType",
  "SaleChannel",
  "Transmission",
  "FuelType",
  "HybridType",
  "Mileage",
  "HasBatteryHealthReport",
  "Grade",
  "MechanicalReportType",
  "LogbookStatus",
  "BodyType",
  "DateRegistered",
  "Plate",
  "CapCleanPrice",
  "EngineCapacity",
  "ColourGeneric",
  "VATType",
  "NumberOfDoors",
];

export const FILTER_NAMES = [
  "VehicleType",
  "Make",
  "Model Group",
  "Model",
  "Derivative",
  "Sale Date",
  "Auction Centre",
  "Vendor / Sale",
  "Sale Channel",
  "Transmission",
  "Fuel Type",
  "Mileage",
  "Battery Grade",
  "Cosmetic Grade",
  "Mechanical Report",
  "V5",
  "Body Type",
  "Vehicle Age",
  "Plate",
  "Price (CAP Clean)",
  "Engine Capacity",
  "Colour",
  "VAT Type",
  "Number of Doors",
];

export const FILTER_NAMES_FOR_TRACKED = [
  "VehicleType",
  "Make",
  "Model Group",
  "Model",
  "Derivative",
  "Sale Date",
  "Location",
  "Vendor / Sale",
  "Sale Channel",
];
